import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";

export default function CreativeThinking() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y1 = useTransform(scrollYProgress, [0, 1], [120, -160]);
    const y2 = useTransform(scrollYProgress, [0, 1], [220, -80]);
    const y3 = useTransform(scrollYProgress, [0, 1], [60, -240]);

    const lines = [c.creative_line1, c.creative_line2, c.creative_line3, c.creative_line4];
    const imgs = [
        "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=600&q=70&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1591994222226-3127b100ed70?w=600&q=70&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1512299286776-c18be8ed6a1a?w=600&q=70&auto=format&fit=crop",
    ];
    const floats = [
        { y: y1, cls: "right-[4%] top-10 w-40 md:w-56" },
        { y: y2, cls: "right-[22%] bottom-8 w-32 md:w-44 hidden md:block" },
        { y: y3, cls: "right-[38%] top-24 w-28 md:w-40 hidden lg:block" },
    ];

    return (
        <section ref={ref} id="creative" data-testid="creative-section" className="grain relative overflow-hidden bg-[#0A0A0A] px-6 py-32 text-white md:px-12 md:py-56 lg:px-24">
            {floats.map((f, i) => (
                <motion.img
                    key={i}
                    src={imgs[i]}
                    alt=""
                    loading="lazy"
                    style={{ y: f.y }}
                    className={`absolute aspect-[3/4] object-cover opacity-25 grayscale ${f.cls}`}
                    aria-hidden="true"
                />
            ))}
            <div className="relative max-w-5xl">
                <Overline testId="creative-overline">Creative thinking — 05</Overline>
                <h2 className="font-display mt-8 text-[clamp(3.2rem,8.5vw,8.5rem)] leading-[0.85]" data-testid="creative-title">
                    {lines.map((l, i) => (
                        <Reveal key={i} delay={i * 0.08}>
                            <span className={`block ${i === 3 ? "text-[#D60024]" : ""} ${i === 1 ? "text-outline-w" : ""}`}>{tx(l)}</span>
                        </Reveal>
                    ))}
                </h2>
                <Reveal delay={0.3}>
                    <p className="mt-12 max-w-md text-base leading-relaxed text-white/65" data-testid="creative-text">
                        {tx(c.creative_text)}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
